/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Intro_P1_AInputs */

const es_privacy_policy_intro_p1_a = /** @type {(inputs: Privacy_Policy_Intro_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata es una plataforma de conocimiento empresarial desarrollada por`)
};

const en_privacy_policy_intro_p1_a = /** @type {(inputs: Privacy_Policy_Intro_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata is an enterprise knowledge platform developed by`)
};

/**
* | output |
* | --- |
* | "Nexata is an enterprise knowledge platform developed by" |
*
* @param {Privacy_Policy_Intro_P1_AInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_intro_p1_a = /** @type {((inputs?: Privacy_Policy_Intro_P1_AInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Intro_P1_AInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_intro_p1_a(inputs)
	return en_privacy_policy_intro_p1_a(inputs)
});
export { privacy_policy_intro_p1_a as "privacy_policy.intro.p1_a" }